import { render } from "./SobreNos.vue?vue&type=template&id=1f7b0767&scoped=true"
import script from "./SobreNos.vue?vue&type=script&lang=js"
export * from "./SobreNos.vue?vue&type=script&lang=js"

import "./SobreNos.vue?vue&type=style&index=0&id=1f7b0767&lang=scss&scoped=true"

import exportComponent from "C:\\Dev\\Vue\\intensione\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7b0767"]])

export default __exports__